export default __webpack_public_path__ + "static/media/shopping-cart-svgrepo-com.4d6e4cf1.svg";